import { graphql } from 'relay-runtime';

export const COMPLETE_TRANSACTION_MUTATION = graphql`
  mutation CompleteTransactionMutation($token: String!) {
    unified {
      linking {
        completeTransaction(token: $token) {
          message
          success
          errors {
            extensions {
              errorType
              statusCode
            }
            code
            message
          }
        }
      }
    }
  }
`;
